//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IToastNotification,
  ToastType,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';

const baseToast = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
};

const LEARN_MORE_URL =
  'https://support.bazaarvoice.com/s/article/Video-Settings?language=en_US';

export const captionBulkRequestToast: IToastNotification = {
  ...baseToast,
  title: 'Updating selected videos...',
  message: `Updates can take a few minutes.`,
};

export const captionFailedToast = (
  captionValue: string,
): IToastNotification => {
  return {
    ...baseToast,
    title: 'Failed',
    message: `We weren't able to turn ${captionValue} captions for a few selected videos.`,
    type: ToastType.ERROR,
  };
};
export const captionMaxTryFailedToast = (
  captionValue: string,
): IToastNotification => {
  return {
    ...baseToast,
    title: 'Failed',
    message: `We weren't able to turn ${captionValue} captions. Please try again.`,
    type: ToastType.ERROR,
  };
};

export const captionInvalidCuidToast = (
  captionValue: string,
): IToastNotification => {
  return {
    ...baseToast,
    title: 'Failed',
    message: `The requested video is not available to turn ${captionValue} captions. `,
    type: ToastType.ERROR,
  };
};

export const captionSuccessToast = (
  captionValue: string,
): IToastNotification => {
  return {
    ...baseToast,
    title: 'Success',
    message: `Captions turned ${captionValue} successfully.`,
  };
};

const openLearnMoreInNewTab = (url: string) => {
  window.open(url, '_blank');
};

export const imagesSelectionFailedToast: IToastNotification = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    extraData: {
      callback: () => openLearnMoreInNewTab(LEARN_MORE_URL),
      linkText: `Learn more`,
    },
  },
  title: 'Selection error',
  message: `Can't update the selected media.`,
  type: ToastType.ERROR,
};

export const cpationSelectionLimitToast: IToastNotification = {
  ...baseToast,
  title: 'Too many videos selected',
  message: `Can't turn on captions for more than 10 videos at once. Select less videos to turn on captions.`,
  type: ToastType.ERROR,
};
